module.exports = __webpack_public_path__ + "img/icon(13).38e45cc2.png";